<ndt-register-view
   [name]="name"
   [totalCount]="totalCount"
   [callState]="callState"
   [hasNextPage]="hasNextPage"
   [pagingCallState]="pagingCallState"
   (quickFilterChange)="onQuickFilterChange($event)"
   (loadMore)="onLoadMore()"
   [pluralNameOverride]="'Mailboxes'"
>
   <lcs-responsive-table [columns]="columns">
      <table lcs-table [dataSource]="dataSource">
         <tr lcs-header-row *lcsResponsiveHeaderRowDef></tr>
         <tr lcs-row *lcsResponsiveRowDef></tr>
         <ng-container lcsColumnDef="name" width="4">
            <th
               class="register-column-header"
               lcs-header-cell
               *lcsHeaderCellDef
               id="displayName-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               sortDirection="Asc"
               sortField="extension.name"
               >Name <mat-icon class="mat-icon-sort">{{ getSort('extension.name') }}</mat-icon></th
            >
            <td lcs-cell *lcsCellDef="let mailbox">
               <a [routerLink]="getRouterLink(mailbox.mailboxId)">
                  {{ mailbox.extension.name }}
               </a>
            </td>
         </ng-container>
         <ng-container lcsColumnDef="number" width="3">
            <th
               class="register-column-header"
               lcs-header-cell
               *lcsHeaderCellDef
               id="emailAddress-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               sortDirection="Notset"
               sortField="extension.number"
               >Number <mat-icon class="mat-icon-sort">{{ getSort('extension.number') }}</mat-icon></th
            >
            <td lcs-cell *lcsCellDef="let mailbox">
               <a [routerLink]="getRouterLink(mailbox.mailboxId)">
                  {{ mailbox.extension.number }}
               </a>
            </td>
         </ng-container>
         <ng-container lcsColumnDef="type" width="3">
            <th
               class="register-column-header"
               lcs-header-cell
               *lcsHeaderCellDef
               id="emailAddress-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               sortDirection="NOT_SET"
               sortField="extension.extensionType.name"
               >Type <mat-icon class="mat-icon-sort">{{ getSort('extension.extensionType.name') }}</mat-icon></th
            >
            <td lcs-cell *lcsCellDef="let mailbox">
               <a [routerLink]="getRouterLink(mailbox.mailboxId)">
                  {{ mailbox.extension.type | formatMailboxTypes }}
               </a>
            </td>
         </ng-container>
         <ng-container lcsColumnDef="emailAddress" width="6">
            <th
               class="register-column-header"
               lcs-header-cell
               *lcsHeaderCellDef
               id="emailAddress-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               sortDirection="Notset"
               sortField="emailAddress"
            >
               Email Address<mat-icon class="mat-icon-sort">{{ getSort('emailAddress') }}</mat-icon></th
            >
            <td lcs-cell *lcsCellDef="let mailbox">
               <a [routerLink]="getRouterLink(mailbox.mailboxId)">
                  {{ mailbox.emailAddress }}
               </a>
            </td>
         </ng-container>
         <ng-container lcsColumnDef="messageCount" width="3">
            <th
               class="register-column-header numeric"
               lcs-header-cell
               *lcsHeaderCellDef
               id="totalCount-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               sortDirection="Notset"
               sortField="unreadMailboxMessageCount"
               >Unread Messages
               <mat-icon class="mat-icon-sort">{{ getSort('unreadMailboxMessageCount') }}</mat-icon></th
            >
            <td lcs-cell *lcsCellDef="let mailbox" class="numeric">
               @if (mailbox.extension?.type !== 'SmartVoicemail') {
               <a [routerLink]="getRouterLink(mailbox.mailboxId)">
                  {{ mailbox.unreadMailboxMessageCount }}
               </a>
               }
            </td>
         </ng-container>
         <ng-container lcsColumnDef="mailboxActionsMenu" width="1">
            <th lcs-header-cell *lcsHeaderCellDef id="mailbox-actions-menu-column-header"></th>
            <td lcs-cell *lcsCellDef="let mailbox">
               <button
                  type="button"
                  aria-label="Mailbox Actions"
                  matTooltip="More Actions"
                  mat-icon-button
                  [matMenuTriggerFor]="mailboxRolesMenu"
                  id="extension-group-more-actions"
               >
                  <mat-icon> more_horiz </mat-icon>
               </button>
               <mat-menu #mailboxRolesMenu="matMenu">
                  <a mat-menu-item [routerLink]="getRouterLink(mailbox.mailboxId)"> Details </a>
               </mat-menu>
            </td>
         </ng-container>
      </table>
   </lcs-responsive-table>
</ndt-register-view>
